
jQuery(function ($) {
    var infoPromoCombinations = function () {
        document.querySelectorAll('.promoComponent').forEach(promoComponent => {
            const mediaQueryMob = matchMedia('(min-width:768px)');
            if (mediaQueryMob.matches) {

                const rows = promoComponent.querySelectorAll('.container .row.gapincard.gapinInfocard');
                rows.forEach(row => {
                    // Select all the .article-infographic-wrapper and .promoComponentRedsign elements within the row
                    const articleWrappers = row.querySelectorAll('.article-infographic-wrapper');
                    const promoRedesigns = row.querySelectorAll('.promoComponentRedsign .component.component-pushbox');

                    articleWrappers.forEach((article, index) => {
                        const promoRedesign = promoRedesigns[index];

                        if (article && promoRedesign) {
                            const articleHeight = article.offsetHeight;
                            const promoRedesignHeight = promoRedesign.offsetHeight;
                            if (articleHeight == promoRedesignHeight) {
                                //if two cards equal and third card is promobox then 
                                promoRedesigns.forEach(promoRedesignInRow => {
                                    promoRedesignInRowHeight = promoRedesignInRow.offsetHeight;
                                    if (articleHeight == promoRedesignInRowHeight) {

                                    }
                                    else {
                                        const alignBottomElement = promoRedesignInRow.querySelector('.js-align-bottom');
                                        const heightDifference = articleHeight - promoRedesignInRowHeight;
                                        alignBottomElement.style.marginTop = `${heightDifference}px`;
                                    }
                                })
                            }
                            //when info more than  promobox in a single row
                            if (articleHeight > promoRedesignHeight) {
                                const heightDifference = articleHeight - promoRedesignHeight;
                                const alignBottomElement = promoRedesign.querySelector('.js-align-bottom');

                                if (alignBottomElement) {
                                    // Set the margin-top of the .js-align-bottom element to adjust for the height difference
                                    alignBottomElement.style.marginTop = `${heightDifference}px`;
                                }
                            }

                            //when promobox more than info in a single row
                            promoRedesigns.forEach(promoRedesignInRow => {
                                promoRedesignInRowHeight = promoRedesignInRow.offsetHeight;
                                const heightDifference = articleHeight - promoRedesignInRowHeight;
                                const alignBottomElement = promoRedesignInRow.querySelector('.js-align-bottom');
                                if (articleHeight > promoRedesignInRow) {
                                    alignBottomElement.style.marginTop = `${heightDifference}px`;
                                }
                                else {
                                    const articleInfographic = article.querySelector('.article-infographic');
                                    $('.equal_height').removeClass('equal_height');
                                    //check if promo + infographic coming with all infographic combination
                                    document.querySelectorAll('.container').forEach(container => {
                                        const rowsInfo = container.querySelectorAll('.row.gapinInfocard');
                                        rowsInfo.forEach(rowinfo => {
                                            const articleInfo = rowinfo.querySelectorAll('.article-infographic-wrapper .article-infographic');

                                            if (articleInfo.length > 0) {
                                                let maxHeight = 0;

                                                // Reset heights to auto first
                                                articleInfo.forEach(card => card.style.height = 'auto');

                                                // Calculate the maximum height in this container only
                                                articleInfo.forEach(card => {
                                                    const height = card.offsetHeight;
                                                    if (height > maxHeight) {
                                                        maxHeight = height;
                                                    }
                                                });

                                                articleInfo.forEach(card => card.style.height = `${maxHeight}px`);

                                                const mediaQueryMob = window.matchMedia('(max-width: 576px)');
                                                if (mediaQueryMob.matches) {
                                                    articleInfo.forEach(card => card.style.height = 'auto');
                                                }
                                            }
                                        });
                                    });



                                    articleInfographic.style.setProperty('height', `${promoRedesignHeight}px`, 'important');
                                }
                            })
                        }
                    });
                });
            }
        });
    }
    setTimeout(() => {
        infoPromoCombinations();
    }, 200);
    $(window).on('resize', function () {
        infoPromoCombinations();
    });
    infoPromoCombinations();
    $(window).on('resize', function () {
        infoPromoCombinations();
    });
    //infographic list alternate color
    const articleProgressCards = document.querySelectorAll('.infographicList .article-progress');
    const articleProgressBackgrounds = document.querySelectorAll('.infographicList .article-progress .ArticleProgress-backgroundColor');

    articleProgressCards.forEach((card, index) => {
        if (index % 2 === 0) {
            card.classList.add('bg_blue');
            card.setAttribute('data-color', '#6AC0EC');
            const circle = card.querySelector('.article-progress__circle');
            if (circle) {
                circle.setAttribute('data-color', '#E6F0FF');
            }
        } else {
            card.classList.add('bg_lightBlue');
            card.setAttribute('data-color', '#199FD8');
            const circle = card.querySelector('.article-progress__circle');
            if (circle) {
                circle.setAttribute('data-color', '#fff');
            }
        }
        const correspondingBackground = articleProgressBackgrounds[index];
        if (index % 2 === 0) {
            correspondingBackground.classList.add('bg_blue');
        } else {
            correspondingBackground.classList.add('bg_lightBlue');
        }
    });

})
